import type { StudyGuideItem, StudyGuideResponseItems } from "../types";

const fetchStudyGuides = async (
	_bundleId: string,
	_action?: "GET_STUDY_GUIDE_ITEMS" | "GET_STUDY_GUIDE_TAGS",
	_tagID?: string,
) => {
	return {
		fetchStudyGuideItems: {
			items: [] as StudyGuideItem[],
		} satisfies StudyGuideResponseItems,
	};
};

export default fetchStudyGuides;
